import axios from "axios";
import { CATEGORY_URL, ATTRIBUTE_URL, CATEGORY_EXPORT, CATEGORY_IMPORT, PRESIGNED_URL } from "../../../../../constants/config";
import { checkBackgroundTaskStatus as checkSharedBackgroundTaskStatus } from "../../../Common/backgroundTaskStatus";

// CREATE =>  POST: add a new product to the server
export function createCategory(category) {
  let categortData = JSON.stringify(category);
  return axios.post(CATEGORY_URL, categortData);
}
// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findCategories(queryParams) {
  return axios.get(`${CATEGORY_URL}/tree`, { params: queryParams });
}

// get tree category related to the products by category id
export function findCategoryById(id) {
  return axios.get(`${CATEGORY_URL}/${id}`);
}

// get msa_category by Category ID
export function findMsaCategoryById(id) {
  return axios.get(`${CATEGORY_URL}/${id}`, { params: { is_msa_compliant: 1 } });
}

export function listCategories(params = {}) {
  const storedFilter = JSON.parse(localStorage.getItem("category_search_filter")) || {};
  const storedFilters = storedFilter.advance_filters || {};

  const pageNumber = params.pageNumber || 1;
  const pageSize = params.pageSize || 20;
  const searchKey = params.search_key ?? storedFilters.searchText ?? "";
  // A header click persists sortBy/sortField/sortOrder at the top level of category_search_filter
  // (sibling to advance_filters) - that must win over the Advance Filters "Sort by" dropdown's
  // value, which lives nested in advance_filters and gets rewritten on every filter submit.
  const sortField = params.sortField || storedFilter.sortBy || storedFilter.sortField || storedFilters.sortField || "id";
  const sortOrder = params.sortOrder || storedFilter.sortOrder || storedFilters.sortOrder || "desc";
  const isMsaCompliant = params.is_msa_compliant ?? storedFilters.is_msa_compliant ?? "";
  const visibleOnEcom = params.visible_on_ecom ?? storedFilters.visible_on_ecom ?? "";

  return axios.get(
    `${CATEGORY_URL}/list?page=${pageNumber}&page_size=${pageSize}&search_key=${searchKey}&sort_by=${sortField || "id"}:${sortOrder || "desc"}&is_msa_compliant=${isMsaCompliant}&visible_on_ecom=${visibleOnEcom}`
  );
}

export function getCategoriesWithoutParams() {
  return axios.get(`${CATEGORY_URL}/list?page_size=-1`);
}

export function getCategoryList(params) {
  return axios.get(`${CATEGORY_URL}/list`, { params });
}

export function findCategoryAttributes(payload) {
  const id = payload.id;
  const queryParams = payload.queryParams;
  return axios.get(
    `${ATTRIBUTE_URL}/category/${id}?search_key=${queryParams.searchKey}&pageSize=${queryParams.pageSize}&linked=${queryParams.linked}&page=${queryParams.pageNumber}`
  );
}
export function findCategoryAttributesGroups(payload) {
  const id = payload.id;
  const queryParams = payload.queryParams;
  return axios.get(
    `${ATTRIBUTE_URL}/groups/category/${payload.id}?search_key=${queryParams.searchKey}&pageSize=${queryParams.pageSize}&linked=${queryParams.linked}&page=${queryParams.pageNumber}`
  );
}
export function saveCategoryAttribute(payload) {
  return axios.patch(`${ATTRIBUTE_URL}/category/${payload.id}`, payload.categoryAttribute);
}
export function saveCategoryAttributeGroup(payload) {
  return axios.patch(`${ATTRIBUTE_URL}/groups/category/${payload.id}`, payload.categoryAttributeGroup);
}

export function editCatergories(payload) {
  return axios.put(`${CATEGORY_URL}/${payload.id}`, { ...payload });
}

export function bulkUpdateCategoryEcom(payload) {
  return axios.patch(`${CATEGORY_URL}/bulk/ecom`, payload);
}

export function deleteCategory(id) {
  return axios.delete(`${CATEGORY_URL}/${id}`);
}

export function exportCategory(params) {
  return axios.post(`${CATEGORY_EXPORT}`, { ...params });
}

export function importCategory(s3_key) {
  return axios.post(`${CATEGORY_IMPORT}/import`, { s3_key });
}
export function uploadFileToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}
export function getPresignedUrl(key) {
  key = key.replaceAll(" ", "-");

  return axios.post(PRESIGNED_URL, [{ key: key }]);
}
export function checkExportApiStatus(ids) {
  return axios.post(`${CATEGORY_EXPORT}`, { category_ids: ids });
}
// CHECK BACKGROUND STATUS
export function checkBackgroundTaskStatus(id) {
  return checkSharedBackgroundTaskStatus(id);
}
